/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import pdfMake, { createPdf } from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { getQRCodeString } from './QRCode/QRCode';
import moment from 'moment';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const getFileName = () => moment(Date.now()).format('YYYY-MM-DD_H_mm_ss_[imported.pdf]');

export default (data, companyId) => {
  if (data.length < 1) {
    // eslint-disable-next-line no-console
    console.error('Error: file corrupted or empty');
    return;
  }

  const qrMargin = [15, 25];
  const textMargin = [5, 180, 5, 0];
  const orderedUsers = data.slice(0);
  orderedUsers.sort((a, b) => {
    const x = a.fullname.toLowerCase();
    const y = b.fullname.toLowerCase();
    // eslint-disable-next-line no-nested-ternary
    return x < y ? -1 : x > y ? 1 : 0;
  });
  const users = orderedUsers.map((item) => [
    {
      qr: getQRCodeString(
        item.id,
        item.fullname, companyId,
      ),
      margin: qrMargin,
      fit: '180',
    }, {
      text: item.fullname,
      margin: textMargin,
    }, {
      text: item.documentId,
      margin: textMargin,
    },
  ]);

  createPdf({
    content: [
      {
        layout: {

        },
        table: {
          style: 'table',
          headerRows: 0,
          widths: ['auto', 'auto', 'auto'],
          body: [
            ...users,
          ],
        },
      },
    ],
    styles: {
      table: {
        bold: true,
      },
    },
  }).download(getFileName());
};
